//local server
// export const VUE_WEB_BASEURL = "http://127.0.0.1:8000/";
// export const VUE_APP_BASEURL = "http://127.0.0.1:8000/api/v1/";

//live server
// export const VUE_APP_BASEURL = "https://admin.kannancrackers.in/api/v1/";
// export const VUE_WEB_BASEURL = "https://admin.kannancrackers.in/";

//live server
// export const VUE_APP_BASEURL = "https://admin.kannancrackers.net/api/v1/";
// export const VUE_WEB_BASEURL = "https://admin.kannancrackers.net/";

//live server
export const VUE_APP_BASEURL = "https://kannanstore.com/api/v1/";
export const VUE_WEB_BASEURL = "https://kannanstore.com/";
